import { render, staticRenderFns } from "./intro-video.vue?vue&type=template&id=3e80b0d4&scoped=true&"
import script from "./intro-video.vue?vue&type=script&lang=js&"
export * from "./intro-video.vue?vue&type=script&lang=js&"
import style0 from "./intro-video.vue?vue&type=style&index=0&id=3e80b0d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../RetirementPlanner.Demo/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e80b0d4",
  null
  
)

export default component.exports